import React from 'react';
import Chart from 'chart.js';

interface ChartProps {
  charttype: string; // e.g. 'line'
  chartdata: Chart.ChartData;
  chartoptions: Chart.ChartOptions;
}

const ChartComponent: React.FC<ChartProps> = ({ charttype, chartdata, chartoptions }) => {
  const ref = React.createRef<HTMLCanvasElement>();

  React.useEffect(() => {
    if (ref.current) {
      const context = ref.current.getContext('2d');
      if (context) {
        new Chart(context, {
          type: charttype,
          data: chartdata,
          options: chartoptions,
        });
      }
    }
  }, []);

  return <canvas ref={ref} />;
};

export default ChartComponent;
